import Cookies from 'js-cookie';

function googleTranslateElementInit() {
	new google.translate.TranslateElement(
		{
			pageLanguage: 'ru',
			layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
			autoDisplay: false,
			gaTrack: true,
			gaId: 'UA-32435293-24',
		},
		'google_translate_element'
	);
}

function getTopDomain() {
	var parts = location.hostname.split('.');
	return parts.slice(-2).join('.');
}

// Load translate API only when either cookie with language is set
// or we have language selected in anchor e.g. /#googtrans(pl)
if (Cookies.get('googtrans') || window.location.hash.indexOf('googtrans(') !== -1) {
	const script = document.createElement('script');
	script.src =
		'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
	script.setAttribute('defer', 'defer');
	document.body.appendChild(script);
}

$('.js-translate__reset').click(function (event) {
	event.preventDefault();
	const link = $(this).attr('href');

	Cookies.remove('googtrans');
	Cookies.remove('googtrans', { domain: '.' + getTopDomain() });

	if (link) {
		window.location = link;
	} else {
		window.location.reload();
	}
});

$('.js-translate__button').click(function () {
	Cookies.set('googtrans', '/ru/' + $(this).data('lang'));
	Cookies.set('googtrans', '/ru/' + $(this).data('lang'), { domain: '.' + getTopDomain() });
	window.location.reload();
});

window.googleTranslateElementInit = googleTranslateElementInit;
